import axios from 'axios';
import url from '../url.js';

const getAuthHeaders = () => {
  const jwtToken = localStorage.getItem('jwtToken');
  return jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};
};

const normalizeArray = (data) => (Array.isArray(data) ? data : []);

export const activityService = {
  // 獲取公開探索活動
  async getPublicActivities() {
    try {
      const response = await axios.get(
        `${url.backendHost}api/activities/public`,
        { withCredentials: true }
      );

      return {
        success: true,
        data: normalizeArray(response.data)
      };
    } catch (error) {
      console.error('獲取公開活動失敗:', error);
      return {
        success: false,
        error: error.response?.data?.message || '獲取公開活動失敗'
      };
    }
  },

  // 獲取單一公開活動預覽
  async getPublicActivityById(activityId) {
    try {
      const response = await axios.get(
        `${url.backendHost}api/activities/public/${activityId}`,
        { withCredentials: true }
      );

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('獲取公開活動預覽失敗:', error);
      return {
        success: false,
        error: error.response?.data?.message || '獲取公開活動預覽失敗'
      };
    }
  },

  // 根據 ID 獲取活動完整資訊
  async getActivityById(activityId) {
    try {
      const headers = getAuthHeaders();
      const response = await axios.get(
        `${url.backendHost}api/activities/${activityId}`,
        { 
          headers, 
          withCredentials: true 
        }
      );

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('獲取活動資訊失敗:', error);
      return {
        success: false,
        error: error.response?.data?.message || '無法獲取活動資訊'
      };
    }
  },

  // 更新活動基本資料
  async updateActivity(activityId, activityData) {
    try {
      const headers = getAuthHeaders();
      const response = await axios.put(
        `${url.backendHost}api/activities/${activityId}`,
        activityData,
        {
          headers,
          withCredentials: true
        }
      );

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('更新活動失敗:', error);
      return {
        success: false,
        error: error.response?.data?.message || '更新活動失敗'
      };
    }
  },

  // 將夥伴添加到活動
  async addPartnerToActivity(partnerId, partnerName, activityId, partnerConfig = {}) {
    try {
      const headers = getAuthHeaders();
      
      const requestData = {
        activityId: parseInt(activityId),
        partnerId: String(partnerId), // 確保是字符串類型
        partnerName: partnerName,
        groupId: null, // null 表示全域夥伴，可以在所有小組中使用
        partnerConfig: {
          isGlobal: true,
          ...partnerConfig
        }
      };

      

      const response = await axios.post(
        `${url.backendHost}api/activities/setupPartner`,
        requestData,
        { 
          headers: {
            ...headers,
            'Content-Type': 'application/json'
          }, 
          withCredentials: true 
        }
      );

      return {
        success: true,
        data: response.data,
        message: '夥伴已成功添加到活動中'
      };
    } catch (error) {
      console.error('添加夥伴到活動失敗:', error);
      
      let errorMessage = '添加夥伴失敗';
      if (error.response?.status === 403) {
        errorMessage = '您沒有權限修改此活動';
      } else if (error.response?.status === 404) {
        errorMessage = '找不到指定的活動';
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      return {
        success: false,
        error: errorMessage
      };
    }
  },

  // 獲取活動的夥伴列表
  async getActivityPartners(activityId) {
    try {
      const headers = getAuthHeaders();
      
      const response = await axios.get(
        `${url.backendHost}api/activities/${activityId}/partners`,
        { headers, withCredentials: true }
      );

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('獲取活動夥伴失敗:', error);
      return {
        success: false,
        error: '獲取夥伴列表失敗'
      };
    }
  },

  // 從活動中移除夥伴
  async removePartnerFromActivity(activityId, partnerId) {
    try {
      const headers = getAuthHeaders();
      
      const response = await axios.delete(
        `${url.backendHost}api/activities/${activityId}/partners/${partnerId}`,
        { headers, withCredentials: true }
      );

      return {
        success: true,
        data: response.data,
        message: '夥伴已從活動中移除'
      };
    } catch (error) {
      console.error('移除夥伴失敗:', error);
      return {
        success: false,
        error: '移除夥伴失敗'
      };
    }
  }
}; 